import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=54bb299e&scoped=true"
import script from "./TasksPage.vue?vue&type=script&lang=js"
export * from "./TasksPage.vue?vue&type=script&lang=js"
import style0 from "./TasksPage.vue?vue&type=style&index=0&id=54bb299e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb299e",
  null
  
)

export default component.exports